import styled from "styled-components"
import { globalMixins } from "../../../assets/styles/styled-components"

export const StyledMenu = styled.div`
  background: ${(props) => props.theme.colors.darkGrey};
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  z-index: 100;
  ${(props) =>
    props.isOpen
      ? `
            pointer-events: initial;
            width: ${props.theme.breakPoints.mobile};
            transition: width .2s linear 0s;
            overflow: visible;
            @media (max-width: ${props.theme.breakPoints.mobile}) {
                width: calc(100% - 16px);
            }
        `
      : `
            width: 0;
            pointer-events: none;
            transition: width .2s linear .2s;
        `}

  &::-webkit-scrollbar {
    display: none;
  }
`
export const StyledMenuInner = styled.div`
  overflow: scroll;
  height: 100vh;
  width: 100%;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding-bottom: 96px;
  }
`

export const StyledHeader = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 32px;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 24px;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    padding: 24px 16px;
  }
  ${(props) =>
    props.pageNavTheme
      ? `
    background: ${props.theme.colors.white};
    border-bottom: 1px solid ${props.theme.colors.darkGrey10};
  `
      : `
    border-bottom: 1px solid ${props.theme.colors.white20};
  `}
`
export const StyledLogo = styled.div`
  width: 132px;
  display: flex;
  cursor: pointer;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    width: 116px;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    width: 108px;
  }
  ${(props) =>
    props.isOpen
      ? `
            opacity: 1;
            transition: opacity .2s linear .2s;
        `
      : `
            opacity: 0;
            transition: opacity .2s linear 0s;
        `}
  ${(props) => props.pageNavTheme && `filter: invert(100%);`}
`
export const StyledTitle = styled.p`
  white-space: nowrap;
  margin: 0;
  margin-top: 16px !important;
  ${(props) =>
    props.isOpen
      ? `
          opacity: 1;
          transition: opacity .2s linear .2s;
      `
      : `
          opacity: 0;
          transition: opacity .2s linear 0s;
      `}

  & a {
    font-family: ${(props) => props.theme.fonts.circularBook};
    font-size: 18px;
    line-height: 22px;
    color: ${(props) => props.theme.colors.darkGrey};
  }
`
export const StyledClose = styled.div`
  cursor: pointer;
  ${(props) =>
    props.isOpen
      ? `
            opacity: 1;
            transition: opacity .2s linear .2s;
        `
      : `
            opacity: 0;
            transition: opacity .2s linear 0s;
        `}

  & svg {
    ${(props) =>
      props.pageNavTheme
        ? `
        color: ${props.theme.colors.darkGrey};
    `
        : `
        color: ${props.theme.colors.white};
    `}
  }
`
export const StyledIcon = styled.div`
  cursor: pointer;
  ${(props) =>
    props.isOpen
      ? `
            transform: rotate(180deg);
            transition: transform .1s linear 0s;
        `
      : `
            transform: rotate(0deg);
            transition: transform .1s linear 0s;
        `}
  & svg {
    ${(props) =>
      props.pageNavTheme
        ? `
          color: ${props.theme.colors.darkGrey};
      `
        : `
          color: ${props.theme.colors.white};
      `}
  }
`
export const StyledNav = styled.nav`
  ${(props) =>
    props.isOpen
      ? `
                    opacity: 1;
                    transition: opacity .2s linear .2s;
                `
      : `
                    opacity: 0;
                    transition: opacity .2s linear 0s;
                `}
  ${(props) =>
    props.pageNavTheme &&
    `
    background: ${props.theme.colors.ivory};
    `}
`

export const StyledNavItem = styled.a`
  font-family: ${(props) => props.theme.fonts.circularBook};
  font-size: 18px;
  display: block;
  padding: 32px;
  white-space: nowrap;
  cursor: pointer;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 16px;
    padding: 24px;
  }
  ${(props) =>
    props.programStyle &&
    `
    font-size: 14px;
    line-height: 18px;
    text-transform: uppercase;
    margin: 0;
    letter-spacing: 1px;
  `}
  ${(props) =>
    props.pageNavTheme
      ? `
    color: ${props.theme.colors.darkGrey};
    border-bottom: 1px solid ${props.theme.colors.darkGrey05};
  `
      : `
    color: ${props.theme.colors.white};
    border-bottom: 1px solid ${props.theme.colors.white20};
  `}
  ${(props) =>
    props.otherMenuTitle &&
    `
      opacity: .5;
      padding: 32px;
      @media (max-width: ${props.theme.breakPoints.tablet}) {
        padding: 24px;
      }
    `}
`
export const StyledNavGroup = styled.div`
  ${(props) =>
    props.pageNavTheme
      ? `
            border-bottom: 1px solid ${props.theme.colors.darkGrey10};
        `
      : `
            border-bottom: 1px solid ${props.theme.colors.white20};
        `}
  ${(props) =>
    props.isOpen
      ? `
                opacity: 1;
                transition: opacity .2s linear .2s;
            `
      : `
                opacity: 0;
                transition: opacity .2s linear 0s;
            `}
`
export const StyledNavGroupHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px;
  cursor: pointer;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 24px;
  }

  & p {
    ${(props) =>
      props.pageNavTheme
        ? `
    font-family: ${props.theme.fonts.circularMedium};
    font-size: 14px;
    line-height: 18px;
    text-transform: uppercase;
    margin: 0;
    letter-spacing: 1px;
    `
        : `
    font-family: ${props.theme.fonts.circularBook};
    font-size: 18px;
    margin: 0;
    @media (max-width: ${props.theme.breakPoints.tablet}) {
      font-size: 16px;
    }`}
  }

  & p {
    color: ${(props) =>
      props.pageNavTheme
        ? props.theme.colors.darkGrey
        : props.theme.colors.white};
  }
`
export const StyledNavGroupChildren = styled.div`
  ${(props) =>
    props.isOpen
      ? `
            display: flex;
            flex-direction: column;
            margin-top: -16px;
            padding: 0 32px 32px 48px;
            @media (max-width: ${props.theme.breakPoints.tablet}) {
                padding: 0 24px 24px 32px;
            }
        `
      : `
            display: none;
        `}
`
export const StyledNavItemChild = styled.div`
  margin: 16px 0 0;

  & a {
    font-family: ${(props) => props.theme.fonts.circularBook};
    font-size: 16px;
    white-space: nowrap;
    cursor: pointer;

    @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
      font-size: 14px;
    }

    ${(props) =>
      props.pageNavTheme
        ? `
    color: ${props.theme.colors.darkGrey80};
  `
        : `
    color: ${props.theme.colors.white80true};
  `}

    @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
      &:hover {
        ${(props) =>
          props.pageNavTheme
            ? `
      color: ${props.theme.colors.black};
    `
            : `
      color: ${props.theme.colors.white};
      font-family: ${(props) => props.theme.fonts.circularMedium};
    `}
      }
    }
  }
`
export const StyledBackground = styled.div`
  background: ${(props) => props.theme.colors.darkGrey60};
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  z-index: 99;
  width: 100%;
  ${(props) =>
    props.isOpen
      ? `
            opacity: 1;
            pointer-events: initial;
            transition: opacity .2s linear 0s;
        `
      : `
            opacity: 0;
            pointer-events: none;
            transition: opacity .2s linear .4s;
        `}
`
export const StyledSecondaryTitle = styled.p`
  font-family: ${(props) => props.theme.fonts.circularMedium};
  color: ${(props) => props.theme.colors.darkGrey};
  margin: 16px 0 0;
  font-size: 18px;
  white-space: nowrap;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 16px;
  }
  ${(props) =>
    props.isOpen
      ? `
            opacity: 1;
            transition: opacity .2s linear .2s;
        `
      : `
            opacity: 0;
            transition: opacity .2s linear 0s;
        `}
`

export const StyledButton = styled.div`
  padding: 32px 24px;
  border-bottom: 1px solid ${(props) => props.theme.colors.white20};
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 24px 16px;
  }
  ${(props) =>
    props.isOpen
      ? `
            opacity: 1;
            transition: opacity .2s linear .2s;
        `
      : `
            opacity: 0;
            transition: opacity .2s linear 0s;
        `}
  & a, & > button {
    width: 100%;
    margin-bottom: 16px;

    &:nth-last-of-type(1) {
      margin-bottom: 0;
    }
  }
`
export const StyledNavTitle = styled.p`
  padding: 32px;
  font-family: ${(props) => props.theme.fonts.circularBook};
  font-size: 18px;
  color: ${(props) => props.theme.colors.white80true};
  margin: 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.white20};
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 24px;
    font-size: 16px;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    padding: 24px 16px;
  }
`
export const StyledOtherMenuTitle = styled.div``

export const StyledPageMenuItemGroupContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${(props) =>
    props.dividing_line &&
    `border-bottom: 0.25px solid #B5B5B5;
    padding-bottom: 16px;
    `}
`
